import React, {useEffect} from 'react';

import {ArticlePageLayout} from '../../components/DataDisplay';
import appConfig from '../../config/appConfig';
import * as localizationKeys from '../../consts/localization/localizationKeys';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import analyticsService from '../../services/analyticsService';
import {getLocalizedStrings} from '../../services/localization/localizationService';
import appRouterService from '../../services/route/appRouterService';

const NotAvailablePage = () => {
    const onClick = () => appRouterService.forwardToContactUsPage();
    const localizedStrings = getLocalizedStrings();
    const iqosStoreUrl = appConfig.getIqosStoreUrlFormatted();
    const buttonPrimary = iqosStoreUrl
        ? {
              onClick,
              textKey: localizationKeys.GLOBAL_CONTACT_US_BTN_TEXT,
          }
        : undefined;

    useDocumentTitle(localizedStrings[localizationKeys.ACCESSIBILITY_SERVICE_NOT_AVAILABLE_PAGE_TITLE]);

    useEffect(() => {
        analyticsService.pushServiceNotAvailable();
    }, []);

    return (
        <ArticlePageLayout
            titleKey={localizationKeys.NOT_AVAILABLE_PAGE_TITLE}
            descriptionKey={localizationKeys.GLOBAL_PLEASE_CONTACT_US}
            buttonPrimary={buttonPrimary}
        />
    );
};

export default NotAvailablePage;
